import { render, staticRenderFns } from "./AbaDadosCadastraisRoute.vue?vue&type=template&id=575da642"
import script from "./AbaDadosCadastraisRoute.vue?vue&type=script&lang=js"
export * from "./AbaDadosCadastraisRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports